import * as _ from 'lodash';
import { ComponentBase, ComponentOptionsBase } from '../../Common/ComponentBase';
import { StringUtils } from '../../Utils/StringUtils';
import { ConfigurationCategory } from './ConfigurationCategory'
import { ConfigurationItem } from './ConfigurationItem'


export interface ConfigurationPanelOptions extends ComponentOptionsBase {
    searchInputId: string;  
    filterSelectId: string;
    configurationFormId: string;
}

export class ConfigurationPanelComponent extends ComponentBase<ConfigurationPanelOptions> {
    private _searchInput: JQuery;
    private _selectedFilter: JQuery;
    private _searchInputId: string;
    private _filterSelectId: string;
    private _configurationFormId: string;
    private _configurationItems: ConfigurationItem[];
    private _configurationCategories: ConfigurationCategory[];

    constructor(options: ConfigurationPanelOptions) {
        super(options);
        this._searchInputId = options.searchInputId;
        this._filterSelectId = options.filterSelectId;
        this._configurationFormId = options.configurationFormId;
        this.onFilterChange = this.onFilterChange.bind(this);
        this.onSubmit = this.onSubmit.bind(this);
        this.hideAllCategories = this.hideAllCategories.bind(this);
        this.showAllCategories = this.showAllCategories.bind(this);
        this.mapAllItems();
        this.mapAllCategories();
    }

    // Map all configuration items from page.
    private mapAllItems() {
        this._configurationItems = new Array();
        let items = $("dt.configurationItem");
        for (let i = 0; i < items.length; i++) {
            let item = items[i]
            let configuration = new ConfigurationItem(item);
            this._configurationItems.push(configuration);
        }
    }

    private mapAllCategories() {
        this._configurationCategories = new Array();
        let categories = $(".collapsible");
        for (let i = 0; i < categories.length; i++) {
            let category = categories[i];
            let configurationCategory = new ConfigurationCategory(category);
            this._configurationCategories.push(configurationCategory);
        }
    }

    // Determine if status should be visible regarding to filter.
    private itemIsVisible(item: ConfigurationItem): boolean {
        let filter = this._selectedFilter.val();
        let searchValue = (this._searchInput.val() as string).trim();
        if (StringUtils.equals(filter, "unfilled") && !StringUtils.isNullOrEmpty(item.getValue())) {
            return false;
        }
        if (StringUtils.equals(filter, "required") && !item.isRequired) {
            return false;
        }
        if (StringUtils.equals(filter, "validationError") && item.isValid()) {
            return false;
        }
        if (StringUtils.equals(filter, "leaf") && !item.isLeaf) {
            return false;
        }
        if (StringUtils.equals(filter, "edited") && !item.isSet()) {
            return false;
        }
        if (StringUtils.equals(filter, "filled") && !item.isSet() && !item.jurisdictionOverride) {
            return false;
        }
        if (item.name.toLowerCase().search(searchValue.toLowerCase()) === -1 && item.code.toLowerCase().search(searchValue.toLowerCase()) === -1) {
            return false;
        }
        return true;
    }

    // Apply filter when change.
    private onFilterChange() {
        sessionStorage.setItem("searchInput", this._searchInput.val());
        this.showAllCategories();
        for (let i = 0; i < this._configurationItems.length; i++) {
            let item = this._configurationItems[i];
            if (this.itemIsVisible(item)) {
                item.show();
            }
            else {
                item.hide();
            }
        }
    }

    // Overrides submit. Handle validation before submit.
    private onSubmit(e: JQueryEventObject) {
        for (let i = 0; i < this._configurationItems.length; i++) {
            this._configurationItems[i].validateField();
            if (!this._configurationItems[i].isValid()) {
                e.preventDefault();
                (this._selectedFilter[0] as HTMLSelectElement).value = "validationError";
                this._searchInput.val('');
                this.onFilterChange();
                return;
            }
        }
    }

    private showAllCategories() {
        for (let i = 0; i < this._configurationCategories.length; i++) {
            this._configurationCategories[i].show();
        }
    }

    private hideAllCategories() {
        for (let i = 0; i < this._configurationCategories.length; i++) {
            this._configurationCategories[i].hide();
        }
    }

    private onFileChange() {
        var fileInput = $("#configuration-file");
        if (fileInput.val()) {
            $("#fileForm").submit();
        }
    }

    private uploadClick() {
        $("#configuration-file").trigger('click');
    }

    // Init configuration panel page.
    init(): void {
        this._searchInput = $("#" + this._searchInputId);
        this._searchInput.on("keyup", this.onFilterChange);
        this._searchInput.val(sessionStorage.getItem("searchInput"));
        this._selectedFilter = $("#" + this._filterSelectId);
        this._selectedFilter.on("change", this.onFilterChange);
        this.onFilterChange();
        $(`#${this._configurationFormId}`).on("submit", this.onSubmit);
        $(".expand-icon").on("click", this.showAllCategories);
        $(".collapse-icon").on("click", this.hideAllCategories);
        $("#btnUpload").on("click", this.uploadClick);
        var configurationFile = $("#configuration-file");
        if (configurationFile) {
            configurationFile.on("change", this.onFileChange);
        }
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Components/ConfigurationPanel/Component.ts
 **/